import { Component, Optional, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { UserLoginModel } from '../../../shared/models/business-transaction/user-login.model';
import { BaseComponent } from '../../../shared/base-components/base.component';

export class ReassignmentData {
    constructor(
        public businessTransactionNumberId: string,
        public recipient: UserLoginModel,
        public originalOwner: UserLoginModel) {}
}

@Component({
    selector: 'reassign-active-modal',
    templateUrl: './reassign-active-modal.html'
})

export class ReassignActiveWindow extends BaseComponent {
    context: ReassignmentData;

    constructor(
        public dialogRef: MatDialogRef<ReassignActiveWindow>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: ReassignmentData
    ) {
        super();
        this.context = data;
    }

    ngOnInit() {
    }

    public accept() {
        this.dialogRef.close(true);
    }

    public cancel() {
        this.dialogRef.close();
    }
}
